var exports = {
  "OD": "xdbfd91f1--659c00--scroll-track",
  "W2": "xdbfd91f1--659c00--scroll",
  "kn": "xdbfd91f1--659c00--scroll--right",
  "bM": "xdbfd91f1--659c00--scroll--left",
  "m1": "xdbfd91f1--659c00--arrow--right",
  "Pr": "xdbfd91f1--659c00--arrow--left",
  "UE": "xdbfd91f1--659c00--arrow",
};

module.exports = exports;
